export default "__VITE_ASSET__BmkirbXd__"